// @ts-check
import styled from 'styled-components';
import { Flex, Padding } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';
import InLoveDude from 'images/characters/inlove-dude.svg';
import Text from 'components/base/Text';
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button';
import AppRouter from 'common/AppRouter';
import QueryString from 'query-string';
import moment from 'moment';
import { SEARCH_DATE_FORMAT, TRACKING } from 'common/constants/constants';
import { SettingValues } from 'common/services/settings.service';
import { SIZES } from 'common/constants/sizes';
import * as TrackingService from 'common/services/tracking.service';
import useSettingsService from 'components/hooks/useSettingsService';
import { LBButton, LBXIcon } from '@linearb/buzz';

const Wrapper = styled(Flex)`
  justify-content: space-between;
  border-radius: 0.45rem;
  background-color: ${getColor('white')};
  width: 100%;
  margin-bottom: 1rem;
`;
const Character = styled.img`
  padding-top: 1rem;
  padding-left: 1.5rem;
  height: 3.5rem;
`;
const Separator = () => (
  <Text size='x-large' color='botticelli'>
    |
  </Text>
);
const PaddedLink = ({ children, onClick }) => (
  <Padding l='small' r='small'>
    <Link onClick={onClick} style={{ fontSize: SIZES.medium }}>
      {children}
    </Link>
  </Padding>
);
const PulseDashboardBar = ({
  history,
  latestIteration,
  goToPreviousIteration,
  onClose
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();
  const onWorkAtRiskClick = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.DASHBOARD,
      page_tab: TRACKING.PAGE_TABS.SHORTCUTS,
      click_type: TRACKING.CLICK.RISKY_WORK_SHORTCUT
    });
    const newWorkSmallTopRange =
      getSettingOrDefinitionValue({
        name: SettingValues.NEW_WORK_SMALL_TOP_RANGE
      }) || 0;
    const codeChangesMediumTopRange =
      getSettingOrDefinitionValue({
        name: SettingValues.CODE_CHANGES_MEDIUM_TOP_RANGE
      }) || 0;
    const searchParams = {
      order_by: `code_changes,desc`,
      updated: `${latestIteration.start_date},${latestIteration.end_date}`,
      'PR Size': `>${codeChangesMediumTopRange}`,
      new_work: `${0}-${newWorkSmallTopRange}`,
      pit: moment().format(SEARCH_DATE_FORMAT)
    };
    history.push({
      pathname: AppRouter.BRANCH.path,
      search: `?${QueryString.stringify(searchParams)}`
    });
  };

  return (
    <Wrapper>
      <Flex items='center'>
        <Character src={InLoveDude} />
        <Flex items='baseline'>
          <Text size='x-large' color='shark' pl='1.5rem'>
            Your team’s pulse screen is ready!
          </Text>
          <Text size='medium' color='shark' pl='4rem'>
            Check out one of these views:
          </Text>
          <PaddedLink
            onClick={() => {
              history.push(AppRouter.PULSE.path);
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.DASHBOARD,
                page_tab: TRACKING.PAGE_TABS.SHORTCUTS,
                click_type: TRACKING.CLICK.PULSE_VIEW_SHORTCUT
              });
            }}
          >
            Pulse view
          </PaddedLink>
          <Separator />
          <PaddedLink
            onClick={() => {
              goToPreviousIteration();
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.DASHBOARD,
                page_tab: TRACKING.PAGE_TABS.SHORTCUTS,
                click_type: TRACKING.CLICK.RETROSPECT_SHORTCUT
              });
            }}
          >
            Iteration Retrospect
          </PaddedLink>
          <Separator />
          <PaddedLink onClick={onWorkAtRiskClick}>work at Risk</PaddedLink>
        </Flex>
      </Flex>

      <Flex items='center'>
        <Flex items='center' height='2.2rem'>
          <Button
            onClick={() => {
              history.push(`${AppRouter.USERS.path}?isOrgSettings=true`);
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.DASHBOARD,
                page_tab: TRACKING.PAGE_TABS.SHORTCUTS,
                click_type: TRACKING.CLICK.INVITE_USERS_SHORTCUT
              });
            }}
            variant='contained'
          >
            Invite others to LinearB
          </Button>
        </Flex>
        <Flex items='center' pl='small' pr='small'>
          <div className='absolute right-0 top-0 pr-4 pt-4'>
            <LBButton
              id='closeModal'
              onClick={() => {
                onClose();
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.DASHBOARD,
                  page_tab: TRACKING.PAGE_TABS.SHORTCUTS,
                  click_type: TRACKING.CLICK.DISMISS
                });
              }}
              size='icon'
              variant='ghost'
            >
              <LBXIcon />
            </LBButton>
          </div>
        </Flex>
      </Flex>
    </Wrapper>
  );
};

export default PulseDashboardBar;
